import React from 'react';
import { MapPin, Sprout, Package, Wallet } from 'lucide-react';
import { howItWorksSteps } from '../../data/mock';
import Reveal from './Reveal';

const iconMap = { MapPin, Sprout, Package, Wallet };

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-20 md:py-28 bg-[#fafafa]" data-testid="how-it-works-section">
      <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
        {/* Header */}
        <Reveal className="text-center mb-14 md:mb-20">
          <p className="text-[#0C6951] text-sm font-bold tracking-[0.15em] uppercase mb-4">
            Simple Process
          </p>
          <h2 className="text-3xl md:text-5xl font-black text-[#004534] mb-4">
            How It Works
          </h2>
          <p className="text-gray-600 text-base md:text-lg max-w-xl mx-auto">
            Four simple steps from lease to income
          </p>
        </Reveal>

        {/* Steps */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-5">
          {howItWorksSteps.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <Reveal key={item.step} delay={index * 110} className="h-full">
                <div className="relative group h-full" data-testid={`step-${item.step}`}>
                  {/* Connector line between cards (desktop) */}
                  {index < howItWorksSteps.length - 1 && (
                    <div className="hidden lg:block absolute top-14 left-[62%] w-[76%] h-px border-t-2 border-dashed border-[#004534]/15 z-0" />
                  )}

                  <div className="relative z-10 bg-white rounded-3xl p-7 shadow-[0_4px_30px_rgba(0,69,52,0.06)] hover:shadow-[0_12px_50px_rgba(0,69,52,0.12)] hover:-translate-y-1.5 transition-all duration-300 h-full flex flex-col">
                    {/* Big ghost step number */}
                    <span className="absolute top-5 right-6 text-6xl font-black text-[#004534]/[0.05] leading-none select-none">
                      {item.step}
                    </span>

                    {/* Icon badge */}
                    <div className="relative w-14 h-14 rounded-2xl bg-gradient-to-br from-[#004534] to-[#0C6951] flex items-center justify-center mb-5 shadow-lg shadow-[#004534]/20 group-hover:scale-105 transition-transform duration-300">
                      <Icon className="w-7 h-7 text-[#c4e538]" />
                    </div>

                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-[#0C6951] text-xs font-bold tracking-wider uppercase">Step {item.step}</span>
                    </div>
                    <h3 className="text-lg font-bold text-[#004534] mb-2">{item.title}</h3>
                    <p className="text-gray-500 text-sm leading-relaxed">{item.description}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
